<template>
  <span>{{ $t('Length') }}: {{item}}</span>
</template>
<script>
export default {
  props: {
    item: {
      type: String,
      required: true
    }
  }
}
</script>
